import { render, staticRenderFns } from "./ProjectInputForm.vue?vue&type=template&id=6dda0e93&scoped=true&"
import script from "./ProjectInputForm.vue?vue&type=script&lang=js&"
export * from "./ProjectInputForm.vue?vue&type=script&lang=js&"
import style0 from "./ProjectInputForm.vue?vue&type=style&index=0&id=6dda0e93&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dda0e93",
  null
  
)

export default component.exports